export default __webpack_public_path__ + "static/media/TL06.4308241d.mp3";